import { screenSizes } from '../../utilities/media';
export var BREAKPOINTS_SIZES = {
  sm: 0,
  md: screenSizes('tablet'),
  lg: screenSizes('desktop')
};